import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import React from "react";
import { useFormContext } from "react-hook-form";
import { ClientConfiguration } from "../../models/ClientConfiguration/ClientConfiguration";
import { AzureBlobConfiguration } from "../../models/ClientConfiguration/AzureBlobConfiguration";
import FieldError from "../common/FieldError";

interface AzureBlobSectionProps {
  disabled?: boolean;
}

const AzureBlobSection: React.FC<AzureBlobSectionProps> = ({
  disabled
}) => {
  const form = useFormContext<ClientConfiguration>();
  const azureBlobs = form.watch("azureBlobs");
  const azureBlobConfig = azureBlobs?.at(0);

  const handleFieldChange = (
    field: keyof AzureBlobConfiguration,
    value: string,
  ) => {
    form.setValue("azureBlobs", [{
      ...azureBlobConfig!,
      [field]: value,
    }]);
  };

  return (
    <div className="grid grid-cols-12 gap-2">
      <div className="col-span-12">
        <div>
          <Label>Connection String</Label>
          <Input
            className="h-8"
            value={azureBlobConfig?.connectionString || ""}
            onChange={(e) =>
              handleFieldChange("connectionString", e.target.value)
            }
            disabled={disabled}
          />
          <FieldError name="azureBlobs.0.connectionString" />
        </div>
      </div>
      <div className="col-span-12 md:col-span-6">
        <div>
          <Label>Blob Name</Label>
          <Input
            value={azureBlobConfig?.blobName || ""}
            onChange={(e) => handleFieldChange("blobName", e.target.value)}
            disabled={disabled}
          />
          <FieldError name="azureBlobs.0.blobName" />
        </div>
      </div>
      <div className="col-span-12 md:col-span-6">
        <div>
          <Label>CSV Configuration Path</Label>
          <Input
            value={azureBlobConfig?.csvConfigurationPath || ""}
            onChange={(e) =>
              handleFieldChange("csvConfigurationPath", e.target.value)
            }
            disabled={disabled}
          />
          <FieldError name="azureBlobs.0.csvConfigurationPath" />
        </div>
      </div>
    </div>
  );
};

export default AzureBlobSection;
